import { awaitRequests, promise } from '../../../helpers';
import { saveCertificateFiles, sendCertificate } from './index';

const addCertificate = ({ data, uploadList }) => {
    return (dispatch, getState, getFirebase) => {
        // -- add
        const add = d => {
            return getFirebase()
                .firestore()
                .collection('certificates')
                .add(d)
                .then(docRef => promise({ ...d, id: docRef.id }));
        };

        // after add
        const afterAdd = item => {
            const reqs = [];

            // upload files
            reqs.push(dispatch(saveCertificateFiles(item, uploadList)).then(c => dispatch(sendCertificate(c))));

            return awaitRequests(reqs).then(() => promise(item));
        };

        // --
        if (data) {
            return add(data).then(item => afterAdd(item));
        }

        return promise();
    };
};

export default addCertificate;
